// Sayfalar arası seçim (Faturalanacaklar, 19.10.2026): seçilen kayıtlar sayfa değişince silinmez;
// "tümünü seç" o sayfadakileri seçime ekler ya da çıkarır; filtre / arama değişince seçim temizlenir.

export type Secim<T> = Record<string, T>;

/** Filtrenin sayfalama dışındaki kısmı: değişirse önceki seçim geçersizdir. */
export function filtreAnahtari(filtre: any): string {
    if (!filtre) return '';
    const { skip, take, currentPage, ...kalan } = filtre;
    return JSON.stringify(kalan);
}

/** Tek kaydı seçer ya da seçimden çıkarır. */
export function kayitSecimiDegistir<T>(secim: Secim<T>, id: string, kayit: T): Secim<T> {
    const yeni = { ...secim };
    if (yeni[id]) delete yeni[id];
    else yeni[id] = kayit;
    return yeni;
}

/** Sayfadakilerin hepsi seçiliyse sayfadakileri çıkarır, değilse hepsini ekler; diğer sayfaların seçimi korunur. */
export function sayfaSecimiDegistir<T>(secim: Secim<T>, sayfa: T[], idAl: (x: T) => string): Secim<T> {
    const yeni = { ...secim };
    const hepsiSecili = sayfa.length > 0 && sayfa.every(x => !!secim[idAl(x)]);
    sayfa.forEach(x => {
        if (hepsiSecili) delete yeni[idAl(x)];
        else yeni[idAl(x)] = x;
    });
    return yeni;
}

/** Listedeki kayıtların hepsini seçime ekler (filtredeki tümünü seç). */
export function hepsiniEkle<T>(secim: Secim<T>, liste: T[], idAl: (x: T) => string): Secim<T> {
    const yeni = { ...secim };
    liste.forEach(x => { yeni[idAl(x)] = x; });
    return yeni;
}

export interface SecimOzeti {
    seciliSayisi: number
    sayfadaSecili: number
    sayfaTamamSecili: boolean
    /** Sayfanın tamamı seçili ama filtrede daha fazla kayıt var: "Filtredeki N kaydın tümünü seç" gösterilir. */
    tumunuSecTeklifi: boolean
    /** Filtredeki bütün kayıtlar seçili. */
    filtreTamamSecili: boolean
    digerSayfalardaSecili: number
}

export function secimOzeti<T>(secim: Secim<T>, sayfa: T[], idAl: (x: T) => string, toplamKayit: number): SecimOzeti {
    const seciliSayisi = Object.keys(secim).length;
    const sayfadaSecili = sayfa.filter(x => !!secim[idAl(x)]).length;
    const sayfaTamamSecili = sayfa.length > 0 && sayfadaSecili == sayfa.length;
    const filtreTamamSecili = toplamKayit > 0 && seciliSayisi >= toplamKayit;
    return {
        seciliSayisi,
        sayfadaSecili,
        sayfaTamamSecili,
        tumunuSecTeklifi: sayfaTamamSecili && !filtreTamamSecili && toplamKayit > sayfa.length,
        filtreTamamSecili,
        digerSayfalardaSecili: seciliSayisi - sayfadaSecili
    };
}
